import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap, filter, take, map } from 'rxjs/operators';

import { loadTodosFromPage } from '../../../store/todo/todo.actions';
import { selectTodos } from '../../../store/todo/todo.selector';

@Injectable({
  providedIn: 'root',
})
export class TodosGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> {

    return this.store.select(selectTodos).pipe(
        tap(todos => {
            if (!todos?.length) this.store.dispatch(loadTodosFromPage())
        }),
        filter(todos => todos.length > 0),
        take(1),
        map(todos => {
            if (todos.find(el => el.id === +route.params['id'])) return true;
            else return this.router.createUrlTree(['/']);
        })
    );
  }
}
